import { render, staticRenderFns } from "./BackTestDetail.vue?vue&type=template&id=09a103a4&scoped=true&"
import script from "./BackTestDetail.vue?vue&type=script&lang=js&"
export * from "./BackTestDetail.vue?vue&type=script&lang=js&"
import style0 from "./BackTestDetail.vue?vue&type=style&index=0&id=09a103a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a103a4",
  null
  
)

export default component.exports